import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Flex, Popover } from "antd";
import { setBillboardMessages } from "../../store/billboardSlice";
import useSocketData from "../../hooks/useSocketData";
import CustomChip from "./CustomChip";
import { SOCKET_CHANNELS } from "../../util/helper/constants";
import "../../assets/css/BillboardBanner/BillboardBanner.css";

const BillboardBanner = ({ socket }) => {
  const dispatch = useDispatch();

  const { data: billboardMessages, isLoading } = useSelector(
    (state) => state.billboard
  );

  const [showAllMessages, setShowAllMessages] = useState(false);
  const [visibleItems, setVisibleItems] = useState(0);

  const { data: billboardSocketData } = useSocketData(
    socket,
    SOCKET_CHANNELS.BILLBOARD_MESSAGES
  );

  useEffect(() => {
    if (!billboardSocketData) return;

    const hasMessagesFlag = billboardSocketData.some(
      (item) => item.DurationMinutes === "No messages below this line"
    );

    let filteredResults = [];
    if (!hasMessagesFlag) {
      filteredResults = billboardSocketData.filter(
        (item) => item.Action && item.Action !== "No messages below this line"
      );
    }

    dispatch(setBillboardMessages(filteredResults));
  }, [billboardSocketData]);

  useEffect(() => {
    if (!billboardMessages.length) return;
    setVisibleItems(
      billboardMessages.length >= 3 ? 3 : billboardMessages.length
    );
  }, [billboardMessages]);

  const RenderAllMessages = () => (
    <Flex
      vertical
      gap="middle"
      align="flex-start"
      className="allMessages-popover"
    >
      {billboardMessages?.map(({ Action }, index) => (
        <CustomChip key={index} message={Action} limitMessageLength={false} />
      ))}
    </Flex>
  );

  const overflowRenderer = useMemo(() => {
    if (billboardMessages.length <= visibleItems) return null;
    return (
      <Popover
        content={<RenderAllMessages />}
        title="All Messages"
        trigger="click"
        placement="bottomLeft"
        arrow={false}
        open={showAllMessages}
        onOpenChange={(status) => setShowAllMessages(status)}
        align={{
          overflow: {
            adjustX: true, // Allow horizontal adjustment only
            adjustY: false
          }
        }}
      >
        <Button
          className="overflow-indicator"
          onClick={() => setShowAllMessages(true)}
        >
          + {billboardMessages.length - visibleItems}
        </Button>
      </Popover>
    );
  }, [visibleItems, billboardMessages.length, showAllMessages]);

  return !isLoading && billboardMessages.length ? (
    <div className="billboard-wrapper">
      {billboardMessages?.slice(0, visibleItems).map(({ Action }, index) => (
        <CustomChip key={index} message={Action} limitMessageLength />
      ))}
      {overflowRenderer}
    </div>
  ) : null;
};

export default BillboardBanner;
